import { render } from "./edit-reservation.vue?vue&type=template&id=09c752f7"
import script from "./edit-reservation.vue?vue&type=script&lang=js"
export * from "./edit-reservation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__